import { Icon } from "@chakra-ui/react";
import React from "react";
import { HiOutlineChevronDown } from "react-icons/hi2";
import {
  type DropdownIndicatorProps,
  type GroupBase,
  components as selectComponents,
} from "react-select";

export function AnalyticsSelectDropdownIndicator<
  Option,
  IsMulti extends boolean,
  Group extends GroupBase<Option>
>(props: DropdownIndicatorProps<Option, IsMulti, Group>): React.ReactElement {
  return (
    <selectComponents.DropdownIndicator {...props}>
      <Icon as={HiOutlineChevronDown} boxSize="16px" color="gray.400" />
    </selectComponents.DropdownIndicator>
  );
}
